<script>
	import { getContext, onDestroy } from 'svelte'
	import { styles } from '../library/scripts/styles'
	import { url } from '../library/scripts/Setup.svelte'
	import { getCookie } from '../library/scripts/cookie'
	import { storeData, storeSite } from '../library/scripts/Store.svelte'

	// get cookie if user is logged
	let bgColor = 'black'
	let isLogged = false
	const ID = getCookie('id')

	$: if (ID.length > 30) isLogged = true

	$: if (!$storeData) {
		if (!isLogged) document.location = '/#'
		if (isLogged) document.location = '/builder'
	}

	$: if ($storeData) bgColor = $storeData.body

	// the navbar
	let navAlign,
		navBg,
		navBBC,
		navBBS,
		navBBW,
		navBTC,
		navBTS,
		navBTW,
		navFC,
		navFS,
		navFCH,
		navMT,
		navMB,
		navPR,
		navPL,
		navSB,
		navSC,
		navSO

	//title
	let siteTitle

	// image
	let siteImage
	let imgPath

	//image description (set from column title of the block that calls the site)
	let imgDescription

	//introduction (set from column text of the block that call the site )
	let siteIntro

	// the text
	let siteText

	// title, image description, introduction & text settings
	let tFC, tFD, tFF, tFS, tFW, tAV, tAH, txtFS, txtFC, txtFF, txtFSTY, txtFW

	// image settings
	let imgWidth, bTC, bTR, bTS, bTW, bBC, bBR, bBS, bBW, bLC, bLS, bLW, bRC, bRS, bRW, iSC, iSB, iSY, iSX

	const globals = getContext('globals')
	const fsS = globals.fsS
	if ($storeData) {
		$storeData.blocks.forEach((block) => {
			if (block.blockName === 'navbar') {
				navAlign = block.align
				navBg = block.backgroundColor
				navBBC = block.borderBottomColor
				navBBS = block.borderBottomStyle
				navBBW = block.borderBottomWidth + 'px'
				navBTC = block.borderTopColor
				navBTS = block.borderTopStyle
				navBTW = block.borderTopWidth + 'px'
				navFC = block.fontColor
				navFS = block.fontSize
				navFCH = block.fontHover
				navMT = block.marginTop + 'px'
				navMB = block.marginBottom + 'px'
				navPR = block.paddingRight + 'px'
				navPL = block.paddingLeft + 'px'
				navSB = block.shadowBlur + 'px'
				navSC = block.shadowColor
				navSO = block.shadowOffsetY + 'px'
			}

			if (block.blockName === $storeSite.name) {
				// content
				siteTitle = block.content[$storeSite.id - 1].title
				siteImage = block.content[$storeSite.id - 1].image
				imgDescription = block.content[$storeSite.id - 1].imgDesc
				siteIntro = block.content[$storeSite.id - 1].text

				// image settings
				imgWidth = '50%'
				bTC = block.content[$storeSite.id - 1].imageBorderTopColor
				bTR = block.content[$storeSite.id - 1].imageBorderTopRadius + 'px'
				bTS = block.content[$storeSite.id - 1].imageBorderTopStyle
				bTW = block.content[$storeSite.id - 1].imageBorderTopWidth + 'px'
				bBC = block.content[$storeSite.id - 1].imageBorderBottomColor
				bBR = block.content[$storeSite.id - 1].imageBorderBottomRadius + 'px'
				bBS = block.content[$storeSite.id - 1].imageBorderBottomStyle
				bBW = block.content[$storeSite.id - 1].imageBorderBottomWidth + 'px'
				bLC = block.content[$storeSite.id - 1].imageBorderLeftColor
				bLS = block.content[$storeSite.id - 1].imageBorderLeftStyle
				bLW = block.content[$storeSite.id - 1].imageBorderLeftWidth + 'px'
				bRC = block.content[$storeSite.id - 1].imageBorderRightColor
				bRS = block.content[$storeSite.id - 1].imageBorderRightStyle
				bRW = block.content[$storeSite.id - 1].imageBorderRightWidth + 'px'
				iSB = block.content[$storeSite.id - 1].boxShadowBlur + 'px'
				iSC = block.content[$storeSite.id - 1].boxShadowColor
				iSY = block.content[$storeSite.id - 1].boxShadowY + 'px'
				iSX = block.content[$storeSite.id - 1].boxShadowX + 'px'

				// text settings
				txtFC = block.content[$storeSite.id - 1].textFontColor
				txtFF = block.content[$storeSite.id - 1].textFontFamily
				txtFS = block.content[$storeSite.id - 1].textFontSize
				txtFSTY = block.content[$storeSite.id - 1].textFontStyle
				txtFW = block.content[$storeSite.id - 1].textFontWeight
			}

			if (block.blockName === $storeSite.link) {
				// content
				siteText = block.content[0].text

				// title settings

				tFC = txtFC
				tFD = block.blockTitleFontDeco
				tFF = txtFF
				tFS = block.blockTitleFontStyle
				tFW = block.blockTitleFontWeight
				tAV = block.blockTitleAlignVertical
				tAH = block.blockTitleAlignHorizontal
			}
		})
	}

	imgPath = url + '/' + $storeSite.name + '/large/' + siteImage

	const close_site = () => {
		document.location = '#/builder'
	}

	onDestroy(() => {
		storeSite.set(false)
	})
</script>

<body use:styles={{ bgColor }}>
	<div
		class="navbar"
		on:click={close_site}
		on:keydown={close_site}
		use:styles={{
			navAlign,
			navBg,
			navBBC,
			navBBS,
			navBBW,
			navBTC,
			navBTS,
			navBTW,
			navFC,
			navFS,
			navFCH,
			navMT,
			navMB,
			navPR,
			navPL,
			navSB,
			navSC,
			navSO,
		}}
	>
		close
	</div>
	<div class="title" use:styles={{ tFC, tFD, tFF, tFS, tFW, tAH, tAV }}>{siteTitle}</div>
	{#if siteImage}
		<div class="image_container">
			<img
				class="image_"
				use:styles={{
					imgWidth,
					bTC,
					bTR,
					bTS,
					bTW,
					bBC,
					bBR,
					bBS,
					bBW,
					bLC,
					bLS,
					bLW,
					bRC,
					bRS,
					bRW,
					iSC,
					iSB,
					iSY,
					iSX,
				}}
				src={imgPath}
				alt="siteimg"
			/>
			<div class="image_desc" use:styles={{ imgWidth, txtFS, txtFC, txtFF, txtFSTY, txtFW }}>{imgDescription}</div>
		</div>
	{/if}
	<div class="text_outer">
		<div class="site_text">
			<div class="site_intro" use:styles={{ txtFS, txtFC, txtFF, txtFSTY, txtFW }}>{siteIntro}</div>
			<div class="site_text" use:styles={{ txtFS, txtFC, txtFF, txtFSTY, txtFW }}>{siteText}</div>
		</div>
	</div>
</body>

<style>
	body {
		background-color: var(--bgColor);
	}

	.navbar {
		display: flex;
		justify-content: var(--navAlign);
		align-items: center;
		background-color: var(--navBg);
		border-bottom: var(--navBBW) var(--navBBS) var(--navBBC);
		border-top: var(--navBTW) var(--navBTS) var(--navBTC);
		color: var(--navFC);
		font-size: var(--navFS);
		margin-top: var(--navMT);
		margin-bottom: var(--navMB);
		padding-right: 20px;
		box-shadow: 0px var(--navSO) var(--navSB) var(--navSC);
		height: 30px;
		cursor: pointer;
	}

	.navbar:hover {
		color: var(--navFCH);
	}

	.title {
		display: flex;
		justify-content: var(--tAH);
		align-items: var(--tAV);
		color: var(--tFC);
		text-decoration: var(--tFD);
		font-family: var(--tFF);
		font-size: var(--tFS);
		font-weight: var(--tFW);
		width: 100%;
		margin: 20px 0px 30px 0px;
	}

	.image_container {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 100%;
		margin-bottom: 30px;
	}

	.image_ {
		width: var(--imgWidth);
		border-top: var(--bTW) var(--bTS) var(--bTC);
		border-right: var(--bRW) var(--bRS) var(--bRC);
		border-bottom: var(--bBW) var(--bBS) var(--bBC);
		border-left: var(--bLW) var(--bLS) var(--bLC);
		border-top-left-radius: var(--bTR);
		border-top-right-radius: var(--bTR);
		border-bottom-left-radius: var(--bBR);
		border-bottom-right-radius: var(--bBR);
		box-shadow: var(--iSX) var(--iSY) var(--iSB) var(--iSC);
	}

	.image_desc {
		display: flex;
		width: var(--imgWidth);
		justify-content: flex-start;
		color: var(--txtFC);
		font-family: var(--txtFF);
		font-style: var(--txtFSTY);
		font-size: var(--txtFS);
		font-weight: var(--txtFW);
		margin-top: 15px;
	}

	.text_outer {
		display: flex;
		width: 100%;
		justify-content: center;
	}

	.site_intro {
		font-weight: bold;
		font-style: italic;
		color: var(--txtFC);
		font-family: var(--txtFF);
		font-size: var(--txtFS);
		padding: 5% 10% 2% 10%;
	}

	.site_text {
		display: flex;
		flex-direction: column;
		width: 100%;
		white-space: pre-wrap;
		color: var(--txtFC);
		font-family: var(--txtFF);
		font-size: var(--txtFS);
		text-align: justify;
		padding: 0% 10% 5% 10%;
	}
</style>
